<template lang="html">
  <li>
    <div class="coupon-bd">
      <div class="coupon-main">
        <div
          class="price"
          :class="{
            pink: coupon.couponType === 1,
            yellow: coupon.couponType === 2,
            blue: coupon.Source === 3
          }"
        >
          <p>
            <i>&yen;</i><strong>{{ coupon.couponAmount / 100 }}</strong>
          </p>
          <p v-if="coupon.couponType === 2">无门槛使用</p>
          <p v-else>满&yen;{{ coupon.useAmountLimit / 100 }}使用</p>
        </div>
        <div class="title">
          <p>{{ coupon.couponName }}</p>
          <p>{{ coupon.couponDesc }}</p>
        </div>
        <div
          v-if="isLogin"
          class="do-exchange"
          :class="{
            pink: coupon.couponType === 1,
            yellow: coupon.couponType === 2,
            blue: coupon.couponType === 3,
            grey: userScore < coupon.Score,
            'has-geted': hasGet,
            'has-exchange': coupon.UserOverplusNum <= 0 && needScore,
            'has-finished': coupon.userGetCount == 0 && coupon.leftCount === 0
          }"
        >
          <p
            v-if="needScore && coupon.UserOverplusNum > 0"
            class="exchange-desc"
          >
            {{ coupon.Score }}积分兑换
          </p>
          <p :class="{ mt: !needScore }">
            <button
              v-if="
                needScore &&
                userScore >= coupon.Score &&
                coupon.UserOverplusNum > 0
              "
              @click="exchange(coupon)"
            >
              立即兑换
            </button>
            <button v-if="userScore < coupon.Score">积分不足</button>
            <button
              v-if="
                !needScore &&
                coupon.getEndTime > nowTime &&
                !(
                  coupon.userGetLimit > 0 &&
                  coupon.userGetLimit === coupon.userGetCount
                ) &&
                coupon.leftCount > 0
              "
              @click="getRightNow(coupon)"
            >
              立即领取
            </button>
          </p>
        </div>
        <div
          v-else
          class="do-exchange"
          :class="{
            pink: coupon.couponType === 1,
            yellow: coupon.couponType === 2,
            blue: coupon.couponType === 3
          }"
        >
          <p v-if="needScore" class="exchange-desc">
            {{ coupon.Score }}积分兑换
          </p>
          <p :class="{ mt: !needScore }">
            <button v-if="needScore" @click="exchange(coupon)">立即兑换</button>
            <button
              v-if="
                !needScore &&
                !(
                  coupon.userGetLimit > 0 &&
                  coupon.userGetLimit === coupon.userGetCount
                )
              "
              @click="getRightNow(coupon)"
            >
              立即领取
            </button>
          </p>
        </div>
      </div>
      <div class="coupon-time" v-if="isLogin">
        <p>
          <time>{{ coupon.couponUseTimeDesc }}</time>
        </p>
        <p v-if="needScore" v-show="coupon.UserOverplusNum > 1">
          可兑{{ coupon.UserOverplusNum }}次
        </p>
        <p
          v-else
          v-show="
            coupon.userGetLimit > 1 &&
            coupon.userGetLimit - coupon.userGetCount > 0
          "
        >
          可领{{ coupon.userGetLimit - coupon.userGetCount }}次
        </p>
      </div>
      <div class="coupon-time" v-else>
        <p>
          <time>{{ coupon.couponUseTimeDesc }}</time>
        </p>
        <p v-if="needScore" v-show="coupon.OverplusNum > 1">
          可兑{{ coupon.OverplusNum }}次
        </p>
        <p
          v-else
          v-show="
            coupon.userGetLimit > 1 &&
            coupon.userGetLimit - coupon.userGetCount > 0
          "
        >
          可领{{ coupon.userGetLimit - coupon.userGetCount }}次
        </p>
      </div>
    </div>
    <div
      class="coupon-ft default-theme"
      :class="{
        'theme-pink': coupon.couponType === 1,
        'theme-yellow': coupon.couponType === 2,
        'theme-blue': coupon.couponType === 3
      }"
    >
      <span v-if="coupon.couponType === 2">现<br />金<br />券</span>
      <span v-else>满<br />减<br />券</span>
    </div>
  </li>
</template>

<script>
// Source：//0-线上 1-线下 2-全渠道
// couponType：1-满减券 2-现金券 3 折扣券
import { MessageBox } from 'mint-ui'

export default {
  props: {
    incoupon: {
      type: Object,
      default: () => {}
    },
    // 是否为积分兑换券
    needScore: {
      type: Boolean,
      default: false
    },
    userScore: {
      type: Number,
      default: 0
    },
    changeScore: {
      type: Function,
      default: () => () => 0
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      coupon: this.incoupon,
      url_ex: `${this.$$hostname('kapi')}/KOPC-action/inter/exchange4app.do`,
      url_get: `${this.$$hostname('coupon')}/coupon4detail/ReceiveCoupon`,
      fetching: false,
      fetching_get: false
    }
  },
  created() {},
  mounted() {},
  computed: {
    nowTime() {
      return new Date().getTime()
    },
    hasGet() {
      return (
        ((this.coupon.userGetLimit > 0 &&
          this.coupon.userGetLimit === this.coupon.userGetCount) ||
          (this.coupon.userGetCount > 0 && this.coupon.leftCount === 0)) &&
        !this.needScore
      )
    }
  },
  methods: {
    /**
     * 立即兑换
     */
    async exchange(cp) {
      if (this.fetching) {
        return
      }
      this.fetching = true
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      if (!uid || !skey || !this.isLogin) {
        this.fetching = false
        this.unLoginMsg()
        return
      }
      const query = this.$$queryString.stringify({
        skuId: cp.SkuId,
        source: 2,
        uid,
        skey
      })
      const res = await fetch(`${this.url_ex}?${query}`)
      const resJson = await res.json()
      if (resJson.errno === 0) {
        // 兑换成功， -积分，-兑换次数
        this.coupon = {
          ...cp,
          UserOverplusNum: cp.UserOverplusNum - 1
        }
        this.changeScore(cp.Score)
        this.$$toast('兑换成功')
      } else if (resJson.errno === 4) {
        this.unLoginMsg()
      } else {
        this.$$toast(`${resJson.errmsg}`)
      }
      this.fetching = false
    },
    async getRightNow(cp) {
      await this.$$ensureLogin()
      if (cp.userGetLimit > 0 && cp.userGetLimit === cp.userGetCount) {
        return
      }
      if (this.fetching_get) {
        return
      }
      this.fetching_get = true
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      const json = await this.$store.dispatch('userGetCoupon', {
        couponCode: cp.couponCode,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey')
      })
      if (json.code * 1 === 1) {
        this.coupon = {
          ...cp,
          userGetCount: cp.userGetCount + 1
        }
        this.$$toast('领取成功')
      } else if (json.code * 1 === 4) {
        this.$$login()
      } else {
        console.log(json)
        this.$$toast(json.msg)
      }
      this.fetching_get = false
    },
    unLoginMsg() {
      this.$$login()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

li {
  display: flex;
  position: relative;
  margin-bottom: rem(20px);
  overflow: hidden;
  font-size: rem(28px);

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: rem(10px);
    height: 100%; //rem(220px);
    background: url('../../assets/images/coupon-grey-line.png') no-repeat;
    background-size: 100% 100%;
    z-index: 5;
  }
}
.coupon-bd {
  flex: 1;
  position: relative;
  padding: rem(20px) rem(10px) 0 rem(30px);
  background: #fff;
  border-right: none;

  &::after {
    content: '';
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: 0;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 1;
  }
}
.coupon-ft {
  display: flex;
  align-items: center;
  justify-content: center;
  width: rem(70px);
  padding-left: rem(8px);
  background: #ff397e;
  color: #fff;
  line-height: 1.5;

  span {
    margin: auto;
  }

  &.default-theme {
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      height: 100%; // rem(220px);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      z-index: 5;
    }
    &::before {
      width: rem(16px);
      left: 0;
    }
    &::after {
      width: rem(10px);
      right: 0;
    }
  }
  &.theme-pink {
    background: #ff649b;

    &::before {
      background-image: url('../../assets/images/coupon-red-split.png');
    }
    &::after {
      background-image: url('../../assets/images/coupon-red-line.png');
    }
  }
  &.theme-yellow {
    background: #ffb637;
    &::before {
      background-image: url('../../assets/images/coupon-yellow-split.png');
    }
    &::after {
      background-image: url('../../assets/images/coupon-yellow-line.png');
    }
  }
  &.theme-blue {
    background: #53b0ff;
    &::before {
      background-image: url('../../assets/images/coupon-blue-split.png');
    }
    &::after {
      background-image: url('../../assets/images/coupon-blue-line.png');
    }
  }
}
.coupon-main {
  display: flex;
  padding-bottom: rem(25px);
  .price {
    min-width: rem(190px);
    font-size: rem(22px);
    margin-right: rem(20px);

    i {
      display: inline-block;
      margin-top: rem(10px);
      vertical-align: top;
      font-size: rem(32px);
      margin-right: rem(10px);
    }
    strong {
      font-size: rem(80px);
      font-weight: 400;
    }
    > p:first-of-type {
      // color: #ff397e
    }
    > p:last-of-type {
      color: #666;
      margin-top: rem(10px);
    }

    &.pink {
      color: #ff397e;
    }
    &.yellow {
      color: #ffb637;
    }
    &.blue {
      color: #53b0ff;
    }
  }
  .do-exchange {
    width: rem(140px);
    font-size: rem(24px);
    text-align: center;
    color: #ff397e;
    button {
      margin-top: rem(20px);
      font-size: rem(20px);
      padding: rem(5px) rem(20px);
      color: #ff397e;
      @include border(all, #ff397e, 1px, 10px);
    }
    .exchange-desc {
      margin-top: rem(10px);
    }
    .mt {
      margin-top: rem(65px);
    }

    &.yellow {
      color: #ffb637;

      button {
        color: #ffb637;

        &::before {
          border-color: #ffb637;
        }
      }
    }
    &.grey {
      color: #999;
      button {
        color: #999;

        &::before {
          border-color: #999;
        }
      }
    }
    &.blue {
      color: #53b0ff;
      button {
        color: #53b0ff;

        &::before {
          border-color: #53b0ff;
        }
      }
    }
    &.has-geted {
      background: url('//cmspic-10004025.image.myqcloud.com/e1f87810-1dee-11e9-b02d-77de53422510_size_125x100?imageMogr2/quality/80')
        no-repeat;
      background-size: 100%;
    }
    &.has-exchange {
      background: url('//cmspic-10004025.image.myqcloud.com/d043b170-1dee-11e9-b02d-77de53422510_size_125x100?imageMogr2/quality/80')
        no-repeat;
      background-size: 100%;
    }
    &.has-finished {
      background: url('//cmspic-10004025.image.myqcloud.com/ef583c70-1dee-11e9-b02d-77de53422510_size_125x100?imageMogr2/quality/80')
        no-repeat;
      background-size: 100%;
    }
  }
  .title {
    flex: 1;
    margin-top: rem(10px);
    > p:first-of-type {
      display: block;
      text-align: left;
      font-size: rem(32px);
      height: rem(40px);
      line-height: 1.2;
      max-width: rem(250px);
      // max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      em {
        margin-left: rem(10px);
        color: #a947ff;
        font-size: rem(24px);
      }
    }
    > p:last-of-type {
      margin-top: rem(10px);
      display: block;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 2.7em;
      line-height: 1.4;
      // overflow: hidden;
      font-size: rem(24px);
      color: #999;
      max-width: rem(250px);
    }
  }
}
.coupon-time {
  display: flex;
  align-items: center;
  padding: rem(15px) rem(10px) rem(15px) 0;
  font-size: rem(22px);
  color: #999;
  @include border(top, #e8e8e8, 1px, 0, dashed);

  > p:first-child {
    flex: 1;

    .icon-tips {
      margin-left: rem(10px);
      font-size: rem(22px);
    }
  }
  time {
    font-size: rem(24px);
  }
  &::before {
    right: rem(10px);
  }
}
</style>
